import {
  SR_API_ACTION_INVENTORY_GET_BY_BARCODE,
} from 'api/actionTypes';

export default async function getInventoryByBarcode(
  { state, apiClient },
  { barcode }
) {
  return apiClient.postWithState({
    action: SR_API_ACTION_INVENTORY_GET_BY_BARCODE,
    state: state,
    payload: {
      barcode,
    },
  });
}
